export default __webpack_public_path__ + "static/media/arrow.9e9ffd39.svg";